import { createAsyncThunk } from '@reduxjs/toolkit';
import { GET_USERLIST } from '@custom/constant';

const userList = createAsyncThunk('userList', async (data:any) => {
  const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  try {
    let url = `${GET_USERLIST}?limit=${data.pgLimit}&offset=${data.pageNumber}&search=${data.search}&hospitalId=${data.hospitalId}&loggedInUserId=${userId}`;
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default userList;
